const CITYSCOPE_TIME_ZONE = 'Europe/London';

export function formatBlogDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: CITYSCOPE_TIME_ZONE,
  }).format(date);
}
